module.exports = __webpack_public_path__ + "img/img12.af64cb5a.jpg";